<app-header></app-header>

<main class="help-container">
  <section class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">
        How can we
        <span class="gradient-text">help you?</span>
      </h1>
      <p class="hero-subtitle">
        Find answers to common questions, learn how to use Markado, or get in
        touch with our support team.
      </p>

      <div class="search-section">
        <div class="search-container">
          <div class="search-box">
            <input
              type="text"
              placeholder="Search for help articles..."
              class="search-input"
              [(ngModel)]="searchQuery"
              (input)="searchFaq()"
            />
            <button type="button" class="search-button" (click)="searchFaq()">
              <span class="search-icon">🔍</span>
              <span>Search</span>
            </button>
          </div>
        </div>

        <div class="popular-topics">
          <span
            *ngFor="let topic of popularTopics"
            class="topic-tag"
            (click)="searchByTopic(topic)"
            [ngClass]="{ active: selectedTopic === topic }"
          >
            {{ topic }}
          </span>
        </div>
      </div>
    </div>
  </section>

  <section class="faq-section">
    <div class="faq-container">
      <div class="section-header">
        <h2 class="section-title">Frequently Asked Questions</h2>
        <p class="section-description">
          Find quick answers to the most common questions about Markado
        </p>
      </div>

      <div *ngIf="searchQuery || selectedTopic" class="search-results-info">
        <span class="results-text">
          {{ filteredFaqItems.length }} results found for "{{
            searchQuery || selectedTopic
          }}"
        </span>
        <button class="clear-search" (click)="resetSearch()">
          <span class="clear-icon">✕</span>
          Clear search
        </button>
      </div>

      <div class="faq-list" *ngIf="filteredFaqItems.length > 0">
        <div
          *ngFor="let item of filteredFaqItems"
          class="faq-item"
          [ngClass]="{ expanded: item.expanded }"
        >
          <button class="faq-question" (click)="toggleFaq(item)">
            <span class="question-text">{{ item.question }}</span>
            <div class="question-toggle">
              <span class="toggle-icon">+</span>
            </div>
          </button>
          <div class="faq-answer">
            <div class="faq-answer-content">{{ item.answer }}</div>
          </div>
        </div>
      </div>

      <div
        *ngIf="searchQuery && filteredFaqItems.length === 0"
        class="no-results"
      >
        <div class="no-results-icon">🔍</div>
        <h3 class="no-results-title">No results found</h3>
        <p class="no-results-text">
          We couldn't find any FAQs matching your search. Please try different
          keywords or contact us directly.
        </p>
        <button class="clear-search" (click)="resetSearch()">
          <span class="clear-icon">↺</span>
          Show all FAQs
        </button>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>
